import Cookies from 'js-cookie'
import jwt_decode from "jwt-decode";
import { useEffect, useState } from 'react';
const useJWT = () => {
    const [data, setData] = useState<UserInfoProps>()

    useEffect(() => {
        try {
            const jwt = Cookies.get('x-funwoo-token') as string
            setData(jwt_decode(jwt))
        } catch (error) {

        }

    }, [])
    return data
}
export interface UserInfoProps {
    iss: string;
    azp: string;
    aud: string;
    sub: string;
    hd: string;
    email: string;
    email_verified: boolean;
    at_hash: string;
    name: string;
    picture: string;
    given_name: string;
    family_name: string;
    locale: string;
    iat: number;
    exp: number;
}

export { useJWT }